import { useState, useEffect, useCallback } from 'react'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'

export const useFormQuesitos = (idExameRealizado, setRespostasComponentePai) => {
  const exameRealizadoService = useExameRealizadoService()
  
  const [respostasQuesitos, setRespostasQuesitos] = useState([])
  const [processandoRespostas, setProcessandoRespostas] = useState(false)

  const fetchRespostasQuesitos = useCallback(async () => {
    if (idExameRealizado) {
      try {
        const response = await exameRealizadoService.listarRespostasQuesitosDeExameRealizadoAsync(
          idExameRealizado,
          setProcessandoRespostas
        )
        setRespostasQuesitos(response || [])
      } catch (error) {
        console.error('Falha ao carregar respostas dos quesitos:', error)
      }
    }
  }, [idExameRealizado])

  useEffect(() => {
    fetchRespostasQuesitos()
  }, [fetchRespostasQuesitos])

  const handleChangeRespostasQuesitos = useCallback(
    (value, idRespostaQuesito) => {
      setRespostasQuesitos((prevRespostas) => {
        const novaLista = prevRespostas.map((respostaQuesito) => {
          if (respostaQuesito.id === idRespostaQuesito) {
            return { ...respostaQuesito, resposta: value }
          }
          return respostaQuesito
        })
        
        // Sincroniza com o componente pai
        setRespostasComponentePai(novaLista)
        return novaLista
      })
    },
    [setRespostasComponentePai]
  )

  return {
    respostasQuesitos,
    processandoRespostas,
    handleChangeRespostasQuesitos,
  }
}
